import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { BrowserRouter as Router } from 'react-router-dom';
import { Clie, rity, redi, copes, fThread, RouteContainer } from './conrutes';
import { InputChangedProvider } from './context/InputChangedContext';
import styles from './login.module.css';
import logo from './pages/img/login/logo-login.png';

const msalConfig = {
  auth: {
    clientId: `${Clie}`,
    authority: `${rity}`,
    redirectUri: `${redi}`,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);
const App = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <InputChangedProvider>
        <AuthButton />
      </InputChangedProvider>
    </MsalProvider>
  );
};

const AuthButton = () => {
  const { instance, accounts } = useMsal();
  const signIn = () => {
    instance.loginPopup().then(response => {      
    }).catch(error => {
      console.error(error);
    });
  };

  const getAccessToken = async () => {
    const request = {
      scopes: [`${copes}`],
      account: accounts[0]
    };

    try {
      if (accounts.length > 0) {
        const accessTokenResponse = await instance.acquireTokenSilent(request);
        console.log(`Bearer ${accessTokenResponse.accessToken}`)
        const response = await fetch(`${fThread}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${accessTokenResponse.accessToken}`,
            'Content-Type': 'application/json'
          },
        });
      }
    } catch (error) {
      console.error("Error al obtener el token:", error);
      return null;
    }
  };

  
  return (
    <>
      {!accounts.length ? (

      <div className={styles.htmlBody}>
        <div className={styles.loginBody}>
          <div className={styles.wprLogin}>
              
              <div className={styles.cab}>
                  <img className={styles.logo} src={logo} alt="configuraciones del Logo" width="" height=""/>
                  
                  {/*<a className="btnUnapec" href="#">Ir a <span>UNAPEC</span></a>*/}
              </div>
              <div className={styles.cuerpo}>
                  <h1>Inicie sesión para <span>acceder</span> al sistema</h1>
                  <button className={styles.btnLogin} onClick={signIn}>Iniciar sesión</button>
              </div>
              <p className={styles.pie}>Universidad APEC, Av. Máximo Gómez #72, Santo Domingo, República Dominicana, Tel.: <a href="tel:8096860021">(809) 686-0021</a></p>
              
          </div>
        </div>
      </div>
            
      ) : (
        <div>        
          <Router>
            <RouteContainer account = { accounts[0] } />            
          </Router>
        </div>)}
    </>
  );
};

export default App;

{/*<div className={styles.loginBody}>
              <div className={styles.loginContainer}>
              <div className={styles.loginCard}>
                  <div className={styles.loginHeader}>
                      <h2>Iniciar sesión</h2>
                      <p>Precionar el boton de "Iniciar Sessión"</p>
                  </div>
                  
                  <div className="login-form" id="loginForm" >
                      <button className={styles.loginBtn} onClick={signIn}>Iniciar sesión</button>
                  </div>

              </div>
          </div>
            
            </div>*/}